import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';
import { DropdownOption } from '../../shared/models/dropdowm.model';
import { map } from 'rxjs';
import { mapCustomerOrder } from '../models/order.mapper';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(
    pageNumber: number,
    pageSize: number,
    fullname?: string,
    email?: string
  ) {
    let params = '';

    if (fullname) params += `&fullName=${fullname}`;
    if (email) params += `&email=${email}`;

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl +
        `/api/v1/customers?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`
    );
  }

  getById(id: string) {
    return this.http
      .get<ApiResult>(this.apiBaseUrl + '/api/v1/customers/' + id)
      .pipe(
        map((response) =>
          response.data?.orders
            ? {
                ...response,
                data: {
                  ...response.data,
                  orders: response.data.orders.map(mapCustomerOrder),
                },
              }
            : response
        )
      );
  }

  getCountryOptions(): DropdownOption[] {
    return [
      { label: 'Brasil', value: 'br' },
      { label: 'México', value: 'mx' },
      { label: 'Porto Rico', value: 'pr' },
      { label: 'Cuba', value: 'cu' },
      { label: 'El Salvador', value: 'sv' },
      { label: 'República Dominicana', value: 'do' },
      { label: 'Guatemala', value: 'gt' },
      { label: 'Colômbia', value: 'co' },
      { label: 'Honduras', value: 'hn' },
      { label: 'Venezuela', value: 've' },
      { label: 'Equador', value: 'ec' },
      { label: 'Peru', value: 'pe' },
      { label: 'Nicarágua', value: 'ni' },
    ];
  }
}
